<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-row class="product-row-list">
    <v-col class="pl-5">
      <!--{{ product.nickcode}}-->
      {{ product.nickname}}
      <span v-if="product.unit_primitive === 'CTN'"
      class="red pl-1 pr-1" style="color: white">
        ยกหีบ
      </span>
      <v-btn
          v-if="product.non_over_stock"
          class="ml-1 orange pa-1 caption"
          style="color: white" x-small>
        !! สินค้าไม่ผลิตเพิ่ม
      </v-btn>

      <v-btn
          v-if="product.type_code!='TRAD_OFM' && product.weight === 0"
          class="ml-1 red pa-1 caption"
          style="color: white" x-small>
        !! สินค้าไม่มีน้าหนัก
      </v-btn>
      <v-btn
          v-if="product.type_code!='TRAD_OFM' && product.volume === 0"
          class="ml-1 red pa-1 caption"
          style="color: white" x-small>
        !! สินค้าไม่มี cbm
      </v-btn>

    </v-col>
    <v-col v-if="$store.state.carts.current.id" class="col-3 text-left stock">
          <span class="float-right">
            {{$helper.number_format(product.stock_MT * product.unit_prim_rate-product.reserve_MT)}}<span class="unit">{{$helper.parseUnit(product.unit_primitive)}}</span>
            /
          {{product['price_'+$store.state.carts.current.price_group]}}<span class="currency">บ.</span>
          </span>

    </v-col>
    <v-col v-else class="col-3 text-right stock">
      <!--<span v-if="product.stock_MT>0">MT: {{ product.stock_MT}}<span class="unit">{{product.unit_single}}</span>-->
      <!--/ {{ product.price_MT}}<span class="currency">บ.</span>-->
      <!--</span>-->
      <!--<br v-if="product.stock_MT>0 && product.stock_PJ>0"/>-->
      <!--<span v-if="product.stock_PJ>0">PJ: {{ product.stock_PJ}}<span class="unit">{{product.unit_single}}</span>-->
      <!--/ {{ product.price_PJ}}<span class="currency">บ.</span>-->
      <!--</span>-->
      <span class="float-right">
            {{$helper.number_format(product.stock_MT * product.unit_prim_rate-product.reserve_MT)}}<span class="unit">{{$helper.parseUnit(product.unit_primitive)}}</span>
          </span>

    </v-col>
    <v-col class="col-2 text-right pr-5">
      <v-btn class="add-button" :class="$store.state.carts.current_item_map[product.id]?'primary':''"
             :disabled="product.non_over_stock && product.stock_MT * product.unit_prim_rate-product.reserve_MT<=0"
             @click.stop="onClickAddCart(product)">เพิ่ม
        <span v-if="$store.state.carts.current_item_map[product.id]">
              {{$store.state.carts.current_item_map[product.id].quantity}}</span>
      </v-btn>
    </v-col>
  </v-row>


</template>
<style lang="scss" scoped>
  .stock {
    font-size: 20px;
  }

  .unit {
    font-size: 0.7em;
  }

  .percent {
    font-size: 0.7em;
  }

  .currency {
    /*display: block;*/
    /*width: 32px;*/
    /*float: right;*/
    font-size: 0.7em;
  }

  .product-row-list {
    font-size: 22px;
    height: 65px;
    align-items: center;
    line-height: 1.2;

    .col {
      padding: 4px;
    }
  }

  @media (max-height: 700px) {
    .add-button {
      padding: 0 4px !important;
      min-width: 10px !important;
    }
    .product-row-list {
      font-size: 18px;
    }
    .stock {
      font-size: 16px;
    }
  }


</style>

<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'
  import {Product} from '../../models/Product'

  @Component({
    components: {},
  })
  export default class ProductRowGrid extends Vue {
    @Prop() product: Product
    @Prop() onClickAddCart: Function

  }

</script>
